import { ReactComponent as PlugDuotone } from '@frontend/icons/plug-duotone.svg';
import { ReactComponent as RouteDuotone } from '@frontend/icons/route-duotone.svg';
import { ReactComponent as ScanreqDuotone } from '@frontend/icons/scan-rec-duotone.svg';
import { ReactComponent as InvoiceDuotone } from '@frontend/icons/invoice-duotone.svg';
import { ReactComponent as GlobeDuotone } from '@frontend/icons/globe-duotone.svg';
import { ReactComponent as WalletDuotone } from '@frontend/icons/wallet-duotone.svg';
import { Icon, Text, TextLink } from '@frontend/ui-library';

export const getInstructionsData = (isOfframp = false) => ({
  wallet: {
    title: isOfframp ? 'How to off ramp' : 'How to pay',
    description: isOfframp
      ? 'To complete your off ramp there are two alternatives:'
      : 'To complete your payment there are two alternatives:',
    instructionGroups: [
      {
        title: 'Connecting a wallet',
        icon: <Icon component={<PlugDuotone />} size={20} color="royal-500" />,
        instructions: [
          'Connect your decentralised wallet',
          'Initiate the transaction here',
          'Approve the transaction in your wallet',
        ],
      },
      {
        title: 'Making a transfer',
        icon: <Icon component={<RouteDuotone />} size={20} color="royal-500" />,
        instructions: (currency: string, network: string) => [
          `Use the address displayed (or scan the QR code) as your transfer’s destination`,
          <>
            Input the required <strong>{currency}</strong> amount to pay
          </>,
          <>
            Select <strong>{network} Network</strong> as the transfer network
          </>,
          `Transfer the funds, ensuring to account for additional fees, such as exchange or network fees`,
        ],
      },
    ],
  },
  manual: {
    title: isOfframp ? 'How to off ramp' : 'How to pay',
    description: isOfframp
      ? 'To complete your off ramp you just need to make a transfer:'
      : 'To complete your payment you just need to make a transfer:',
    instructionGroups: [
      {
        title: 'Making a transfer',
        icon: <Icon component={<RouteDuotone />} size={20} color="royal-500" />,
        instructions: (currency: string, network: string) => [
          `Use the address displayed (or scan the QR code) as your transfer’s destination`,
          <>
            Input the required <strong>{currency}</strong> amount to pay
          </>,
          <>
            Select <strong>{network} Network</strong> as the transfer network
          </>,
          `Transfer the funds, ensuring to account for additional fees, such as exchange or network fees`,
        ],
      },
    ],
  },
  lightning: {
    title: isOfframp ? 'How to off ramp' : 'Paying with Lightning Network',
    description: isOfframp
      ? 'To complete your off ramp there are two alternatives:'
      : 'To complete your payment there are two alternatives:',
    instructionGroups: [
      {
        title: 'Scanning the QR code',
        icon: (
          <Icon component={<ScanreqDuotone />} size={20} color="royal-500" />
        ),
        instructions: [
          'Scan the QR code displayed with a Lightning Network enabled wallet or exchange',
          'Follow the instructions to complete the transfer',
        ],
      },
      {
        title: 'Pasting the invoice code',
        icon: (
          <Icon component={<InvoiceDuotone />} size={20} color="royal-500" />
        ),
        instructions: [
          'Paste the invoice code displayed in a Lightning Network enabled wallet or exchange',
          'Follow the instructions to complete the transfer',
        ],
      },
    ],
  },
  binancePay: {
    title: isOfframp ? 'How to off ramp' : 'Paying with Binance Pay',
    description: isOfframp
      ? 'To complete your off ramp there are two alternatives:'
      : 'To complete your payment there are two alternatives:',
    instructionGroups: [
      {
        title: 'Scanning the QR code',
        icon: (
          <Icon component={<ScanreqDuotone />} size={20} color="royal-500" />
        ),
        instructions: [
          'Scan the QR code displayed with your Binance app',
          'Follow the instructions provided by Binance to complete the transfer',
        ],
      },
      {
        title: 'Opening in browser',
        icon: <Icon component={<GlobeDuotone />} size={20} color="royal-500" />,
        instructions: [
          'Click ‘Open Binance Pay’',
          'Binance Pay will open in a new tab',
          'On the new tab, follow the instructions provided to complete the transfer',
        ],
      },
    ],
  },
  solanaPayDesktop: {
    title: isOfframp ? 'How to off ramp' : 'Paying with Solana Pay',
    description: '',
    customDescription: (
      <>
        <Text as="p" color="vitaminC-500" size="small" mt="8" mb="0">
          This method requires a supported wallet
        </Text>
        <Text as="p" size="small" color="neutral-500" mt="8" mb="0">
          Check the supported wallets{' '}
          <TextLink href="https://docs.solanapay.com/" target="_blank">
            here →
          </TextLink>
        </Text>
      </>
    ),
    instructionGroups: [
      {
        title: 'Scanning the QR code',
        icon: (
          <Icon component={<ScanreqDuotone />} size={20} color="royal-500" />
        ),
        instructions: [
          'Scan the QR code displayed with your Solana Pay supported wallet',
          'Follow the instructions provided by your wallet to complete the transfer',
        ],
      },
    ],
  },
  solanaPayMobile: {
    title: isOfframp ? 'How to off ramp' : 'Paying with Solana Pay',
    description: '',
    customDescription: (
      <>
        <Text as="p" color="vitaminC-500" size="small" mt="8" mb="0">
          This method requires a supported wallet
        </Text>
        <Text as="p" size="small" color="neutral-500" mt="8" mb="0">
          Check the supported wallets{' '}
          <TextLink href="https://docs.solanapay.com/" target="_blank">
            here →
          </TextLink>
        </Text>
      </>
    ),
    instructionGroups: [
      {
        title: 'Opening in wallet',
        icon: (
          <Icon component={<WalletDuotone />} size={20} color="royal-500" />
        ),
        instructions: [
          'Click ‘Pay in Solana wallet’',
          'Your Solana Pay supported wallet will open',
          'Follow the instructions provided by your wallet to complete the transfer',
        ],
      },
    ],
  },
});
